import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import { IoMdAdd } from "react-icons/io";
import { MdOutlineFileUpload } from "react-icons/md";
import Select from "react-select";
import * as XLSX from "xlsx";
import { utils, writeFile } from "xlsx";

const PmSkuMaster = () => {
    const [loadshow, setLoadshow] = useState("show-n");
    const [overlayBlock, setOverlayBlock] = useState("show-n");
    const [overlyBlock, setOverlyBlock] = useState("show-n");
    const [show, setShow] = useState(false);
    const [basicTitle, setBasicTitle] = useState("");
    const [basicType, setBasicType] = useState("default");
    const [rowData, setRowData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    
    const [isSliderOpen, setSliderOpen] = useState(false);
    const [sliderType, setSliderType] = useState(null);
    const [sliderCl, setSliderCl] = useState("");
    const [sliderTitle, setSliderTitle] = useState("");

    const [uploadedFileData, setUploadedFileData] = useState([]);
    const [file, setFile] = useState(null);

    const [editFormData, setEditFormData] = useState({
        pm_sku_code: "",
        pm_type: "",
        pm_category: "",
        pm_sku_name: "",
        pm_sku_sub_category: "",
        lead_time: "",
        moq: "",
        qc_time: "",
        transit_time: "",
        is_active: "1"
    });

    const [duplicatedEditData, setDuplicatedEditData] = useState({
        pm_sku_code: "",
        pm_type: "",
        pm_category: "",
        pm_sku_name: "",
        pm_sku_sub_category: "",
        lead_time: "",
        moq: "",
        qc_time: "",
        transit_time: "",
        is_active: "1"
    });

    const gridApi = useRef(null);
    const gridColumnApi = useRef(null);

    // Status options for dropdown
    const statusOptions = [
        { value: "1", label: "Active" },
        { value: "0", label: "In-Active" }
    ];

    const selectStyles = {
        control: (base) => ({
            ...base,
            padding: '1px',
            borderRadius: '5px',
            border: '1px solid #d9d9d9',
            minHeight: '38px'
        }),
        singleValue: (base) => ({
            ...base,
            fontWeight: 'normal',
            color: '#333',
            fontSize: "12px"
        }),
        option: (base, state) => ({
            ...base,
            fontSize: "13px",
            fontWeight: state.isSelected ? 'normal' : 'normal',
        })
    };

    const actionColumn = {
        headerName: "",
        field: "actions",
        sortable: false,
        filter: false,
        width: "90px",
        cellClass: "custom-cell", 
        cellRendererFramework: (params) => {
            return (
                <div style={{ height: "36px", padding: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <button
                        title="Edit"
                        className="mt-2"
                        style={{
                            height: "30px", 
                            width: "60px",
                            padding: "0 10px",
                            border: "1px solid #93385D",
                            borderRadius: "4px",
                            backgroundColor: "#F4EBEF",
                            fontSize: "0.8rem",
                            color: "#93385D",
                            cursor: "pointer"
                        }}
                        onClick={() => handleEdit(params.data)}
                    >
                        Edit
                    </button>
                </div>
            )
        },
    };

    const columnWithDefs = [
        actionColumn,
        {
            headerName: "SKU Code",
            field: "pm_sku_code",
            tooltipField: "pm_sku_code",
            sortable: true,
            resizable: true,
            width: 150,
                cellStyle: (params) => {
                if (params.data.is_active === 0) {
                return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
            headerName: "Type",
            field: "pm_type",
            tooltipField: "pm_type",
            sortable: true,
            resizable: true,
            width: 120,
                cellStyle: (params) => {
                if (params.data.is_active === 0) {
                return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
            
        },
        {
            headerName: "Category",
            field: "pm_category",
            tooltipField: "pm_category",
            sortable: true,
            resizable: true,
            width: 180,    cellStyle: (params) => {
            if (params.data.is_active === 0) {
            return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
            }
            return null;
        },
        },
        {
            headerName: "SKU Name",
            field: "pm_sku_name",
            tooltipField: "pm_sku_name",
            sortable: true,
            resizable: true,
            width: 250,
                cellStyle: (params) => {
            if (params.data.is_active === 0) {
            return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
            }
            return null;
         },
        },
        {
            headerName: "SKU Sub Category",
            field: "pm_sku_sub_category",
            tooltipField: "pm_sku_sub_category",
            sortable: true,
            resizable: true,
            width: 220,
                cellStyle: (params) => {
            if (params.data.is_active === 0) {
            return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
            }
            return null;
        },
        },
        {
            headerName: "Lead Time",
            field: "lead_time",
            tooltipField: "lead_time",
            sortable: true,
            resizable: true,
            width: 120,
                cellStyle: (params) => {
                if (params.data.is_active === 0) {
                return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
            valueFormatter: (params) => {
                if (params.value !== null && params.value !== undefined) {
                    return params.value.toString();
                }
                return '0';
            }
        },
        {
            headerName: "MOQ",
            field: "moq",
            tooltipField: "moq",
            sortable: true,
            resizable: true,
            width: 100,
                cellStyle: (params) => {
                if (params.data.is_active === 0) {
                return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
            valueFormatter: (params) => {
                if (params.value !== null && params.value !== undefined) {
                    return params.value.toString();
                }
                return '0';
            }
        },
        {
            headerName: "Status",
            field: "is_active",
            sortable: true,
            resizable: true,
            width: 100,
                cellStyle: (params) => {
                if (params.data.is_active === 0) {
                return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
            valueFormatter: (params) => {
                if (params.value === 1 || params.value === "1") {
                    return "Active";
                } else if (params.value === 0 || params.value === "0") {
                    return "In-Active";
                }
                return "Active";
            },
        },
        {
            headerName: "QC Time",
            field: "qc_time",
            tooltipField: "qc_time",
            sortable: true,
            resizable: true,
            hide:true,
            width: 120,
            valueFormatter: (params) => {
                if (params.value !== null && params.value !== undefined) {
                    return params.value.toString();
                }
                return '0';
            }
        },
        {
            headerName: "Transit Time",
            field: "transit_time",
            tooltipField: "transit_time",
            sortable: true,
            hide:true,
            resizable: true,
            width: 140,
            valueFormatter: (params) => {
                if (params.value !== null && params.value !== undefined) {
                    return params.value.toString();
                }
                return '0';
            }
        },
        {
            headerName: "Inserted Date",
            field: "inserted_date",
            tooltipField: "inserted_date",
            sortable: true,
            resizable: true,
            width: 150,
            hide: true,
            valueFormatter: (params) => {
                if (params.value) {
                    return new Date(params.value).toLocaleDateString();
                }
                return '';
            }
        },
        {
            headerName: "Updated Date",
            field: "updated_date",
            tooltipField: "updated_date",
            sortable: true,
            resizable: true,
            width: 150,
            hide: true,
            valueFormatter: (params) => {
                if (params.value) {
                    return new Date(params.value).toLocaleDateString();
                }
                return '';
            }
        }
    ];

    // Handle Edit
    const handleEdit = (rowData) => {
        setEditFormData({
            _id: rowData._id,
            pm_sku_code: rowData.pm_sku_code || "",
            pm_type: rowData.pm_type || "",
            pm_category: rowData.pm_category || "",
            pm_sku_name: rowData.pm_sku_name || "",
            pm_sku_sub_category: rowData.pm_sku_sub_category || "",
            lead_time: rowData.lead_time !== undefined && rowData.lead_time !== null ? rowData.lead_time : "",
            moq: rowData.moq !== undefined && rowData.moq !== null ? rowData.moq : "",
            qc_time: rowData.qc_time !== undefined && rowData.qc_time !== null ? rowData.qc_time : "",
            transit_time: rowData.transit_time !== undefined && rowData.transit_time !== null ? rowData.transit_time : "",
            is_active: rowData.is_active !== undefined && rowData.is_active !== null ? rowData.is_active.toString() : "1"
        });
        
        setDuplicatedEditData({
            pm_sku_code: rowData.pm_sku_code || "",
            pm_type: rowData.pm_type || "",
            pm_category: rowData.pm_category || "",
            pm_sku_name: rowData.pm_sku_name || "",
            pm_sku_sub_category: rowData.pm_sku_sub_category || "",
            lead_time: rowData.lead_time !== undefined && rowData.lead_time !== null ? rowData.lead_time : "",
            moq: rowData.moq !== undefined && rowData.moq !== null ? rowData.moq : "",
            qc_time: rowData.qc_time !== undefined && rowData.qc_time !== null ? rowData.qc_time : "",
            transit_time: rowData.transit_time !== undefined && rowData.transit_time !== null ? rowData.transit_time : "",
            is_active: rowData.is_active !== undefined && rowData.is_active !== null ? rowData.is_active.toString() : "1"
        });

        setSliderOpen(true);
        setSliderType(3);
        setSliderCl("slider-25");
        setSliderTitle(`Edit PM SKU - ${rowData.pm_sku_code}`);
        setOverlyBlock("show-m");
    };

    const handleEditInputChange = (field, value) => {
        setEditFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Update PM SKU
    const onClickingUpdatePmSku = async () => {
        setLoadshow("show-m");
        setOverlayBlock("show-m");  
        
        const isNeedtoUpdate = Object.keys(duplicatedEditData).some(
            (key) => duplicatedEditData[key] !== editFormData[key]
        );

        if (!isNeedtoUpdate) {
            setShow(true);
            setBasicType("info");
            setBasicTitle("No changes made to PM SKU data");
            setLoadshow("show-n");
            setOverlayBlock("show-n");
            return;
        }

        try {
            const response = await redirectURL.post("masters/updatePmSkuMaster", {
                id: editFormData._id,
                pm_sku_code: editFormData.pm_sku_code,
                pm_type: editFormData.pm_type,
                pm_category: editFormData.pm_category,
                pm_sku_name: editFormData.pm_sku_name,
                pm_sku_sub_category: editFormData.pm_sku_sub_category,
                lead_time: editFormData.lead_time,
                moq: editFormData.moq,
                qc_time: editFormData.qc_time,
                transit_time: editFormData.transit_time,
                is_active: editFormData.is_active
            });

            if (response.data.status === "success") {
                await getPmSkuMasterData();
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("success");
                setBasicTitle("PM SKU data updated successfully");
                setSliderOpen(false);
                setOverlyBlock("show-n");
                resetFormData();
            } else {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("info");
                setBasicTitle(response.data.message || "Failed to update PM SKU data");
            }
        } catch (error) {
            console.error("Error updating PM SKU:", error);
            setShow(true);
            setBasicType("info");
            setBasicTitle("Failed to update PM SKU data");
        }
    };

    // Add New PM SKU
    const onClickAddNewPmSku = () => {
        resetFormData();
        setSliderOpen(true);
        setSliderType(1);
        setSliderCl("slider-25");
        setSliderTitle("Add New PM SKU");
        setOverlyBlock("show-m");
    };

    // Upload PM SKU Master Data
    const onClickUploadPmSkuMasterData = () => {
        setSliderOpen(true);
        setSliderType(2);
        setSliderCl("slider-25");
        setSliderTitle("Upload PM SKU Master Data");
        setOverlyBlock("show-m");
        setUploadedFileData([]);
        setFile(null);
    };

    // Handle Add PM SKU
    const handleAddPmSku = async (e) => {
        if (e) e.preventDefault();
        
        setLoadshow("show-m");
        setOverlayBlock("show-m");
        
        const params = {
            pm_sku_code: editFormData.pm_sku_code,
            pm_type: editFormData.pm_type,
            pm_category: editFormData.pm_category,
            pm_sku_name: editFormData.pm_sku_name,
            pm_sku_sub_category: editFormData.pm_sku_sub_category,
            lead_time: editFormData.lead_time,
            moq: editFormData.moq,
            qc_time: editFormData.qc_time,
            transit_time: editFormData.transit_time,
            is_active: "1"
        };

        const requiredFields = ['pm_sku_code', 'pm_type', 'pm_category', 'pm_sku_name', 'pm_sku_sub_category'];
        const validationErrors = requiredFields.filter(
            (key) => !params[key] || params[key].toString().trim() === ""
        );

        if (validationErrors.length > 0) {
            setShow(true);
            setBasicType("info");
            setBasicTitle(`Please fill in all required fields: ${validationErrors.join(", ")}`);
            setLoadshow("show-n");
            setOverlayBlock("show-n");
            return;
        }

        // Validate numeric fields
        const numericFields = ['lead_time', 'moq', 'qc_time', 'transit_time'];
        for (const field of numericFields) {
            if (params[field] && (isNaN(Number(params[field])) || Number(params[field]) < 0)) {
                setShow(true);
                setBasicType("info");
                setBasicTitle(`${field.replace('_', ' ').toUpperCase()} must be a valid positive number`);
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                return;
            }
        }

        try {
            const response = await redirectURL.post("masters/addNewPmSku", params);
        
            if (response.status === 200 && response.data.status === "success") {
                await getPmSkuMasterData();
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("success");
                setBasicTitle("New PM SKU Added Successfully");
                setSliderOpen(false);
                setOverlyBlock("show-n");
                resetFormData();
            } else {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("info");
                setBasicTitle(response.data.message || "Failed to add New PM SKU");
            }
        } catch (error) {
            const message = error.response?.data?.message || "An error occurred";
            setShow(true);
            setBasicType("info");
            setBasicTitle(message);
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    // Reset Form Data
    const resetFormData = () => {
        setEditFormData({
            pm_sku_code: "",
            pm_type: "",
            pm_category: "",
            pm_sku_name: "",
            pm_sku_sub_category: "",
            lead_time: "",
            moq: "",
            qc_time: "",
            transit_time: "",
            is_active: "1"
        });
        setDuplicatedEditData({
            pm_sku_code: "",
            pm_type: "",
            pm_category: "",
            pm_sku_name: "",
            pm_sku_sub_category: "",
            lead_time: "",
            moq: "",
            qc_time: "",
            transit_time: "",
            is_active: "1"
        });
    };

    // Download Excel Template
    const downloadPmSkuExcelTemplate = () => {
        const sampleData = [
            [
                "PM SKU Code",
                "PM Type",
                "PM Category",
                "PM SKU Name",
                "PM SKU Sub Category",
                "Lead Time",
                "MOQ",
                "QC Time",
                "Transit Time"
            ],
        ];

        const ws = utils.aoa_to_sheet(sampleData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Sheet1");

        writeFile(wb, "pm_sku_master_template.xlsx");
    };

    // Handle File Change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFile(e.target.value);
        
        if (!file) return;
        
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const parsedData = XLSX.utils.sheet_to_json(worksheet, {
                    raw: false,
                    dateNF: "yyyy-mm-dd",
                });
                
                // Define field mapping
                const mapping = {
                    "PM SKU Code": "pm_sku_code",
                    "PM Type": "pm_type",
                    "PM Category": "pm_category",
                    "PM SKU Name": "pm_sku_name",
                    "PM SKU Sub Category": "pm_sku_sub_category",
                    "Lead Time": "lead_time",
                    "MOQ": "moq",
                    "QC Time": "qc_time",
                    "Transit Time": "transit_time"
                };

                // Transform data to match your schema
                const result = parsedData.map(item => {
                    const newItem = {};
                    for (const key in item) {
                        if (mapping[key]) {
                            newItem[mapping[key]] = item[key];
                        } else {
                            // Convert to snake_case for any unmapped fields
                            const snakeKey = key.trim()
                                .replace(/\s+/g, '_')
                                .toLowerCase();
                            newItem[snakeKey] = item[key];
                        }
                    }
                    return newItem;
                });

                console.log("Parsed PM SKU Data:", result);
                setUploadedFileData(result);
            } catch (error) {
                console.error("Error parsing file:", error);
                setShow(true);
                setBasicType("info");
                setBasicTitle("Error parsing the file. Please check the format.");
            }
        };
        reader.readAsArrayBuffer(file);
    };

    // Handle File Submit
    const onClickingFileSubmit = async () => {
        if (uploadedFileData.length === 0) {
            setShow(true);
            setBasicType("info");
            setBasicTitle("Please upload a file or add some data");
            return;
        }

        setLoadshow("show-m");
        setOverlayBlock("show-m");

        try {
            const response = await redirectURL.post(
                "masters/storePmSkuMasterData",
                { masterData: uploadedFileData }
            );
            
            if (response.data.status === "success") {
                await getPmSkuMasterData();
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("success");
                setBasicTitle("PM SKU Data Uploaded Successfully");
                
                // Reset file input and close slider
                if (document.getElementById("pmBulkUploadFile")) {
                    document.getElementById("pmBulkUploadFile").value = "";
                }
                setUploadedFileData([]);
                setSliderOpen(false);
                setOverlyBlock("show-n");
            } else {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("info");
                setBasicTitle(response.data.message || "Data Upload Failed");
            }
        } catch (error) {
            console.error("Upload error:", error);
            const errorMessage = error.response?.data?.message || "Failed to upload data";
            setShow(true);
            setBasicType("info");
            setBasicTitle(errorMessage);
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    // Hide Overlay
    const hideOverlySlideBlock = () => {
        setOverlyBlock("show-n");
        setLoadshow("show-n");
        setSliderOpen(false);
        resetFormData();
        setUploadedFileData([]);
        setFile(null);
        if (document.getElementById("pmBulkUploadFile")) {
            document.getElementById("pmBulkUploadFile").value = "";
        }
    };

    // Close Slider
    const onClickingSliderCloseIcon = () => {
        setOverlyBlock("show-n");
        setSliderOpen(false);
        resetFormData();
        setUploadedFileData([]);
        setFile(null);
        if (document.getElementById("pmBulkUploadFile")) {
            document.getElementById("pmBulkUploadFile").value = "";
        }
    };

    // Grid Sidebar
    const sideBar = useMemo(() => ({
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
            },
        ]
    }), []);

    // Status Panel
    const statusPanel = {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left"
            },
            {
                statusPanel: "agTotalRowCountComponent",
                align: "center"
            },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" }
        ]
    };

    // Default Column Definitions
    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 150,
    };

    // Grid Ready
    const onGridReady = (params) => {
        gridApi.current = params.api;
        gridColumnApi.current = params.columnApi;

        setTimeout(() => {
            if (gridApi.current) {
                gridApi.current.sizeColumnsToFit();
            }
        }, 100);
    };

    const onFirstDataRendered = (params) => {
        setTimeout(() => {
            if (gridApi.current) {
                gridApi.current.sizeColumnsToFit();
            }
        }, 100);
    };

    // Get PM SKU Master Data
    const getPmSkuMasterData = async () => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");
            const response = await redirectURL.post("masters/getPmSkuMasterData", {});

            if (response.status === 200) {
                if (response.data.status === "success" && response.data.data && response.data.data.length > 0) {
                    const data = response.data.data;
                    setRowData(data);
                    setFilteredData(data);
                } else {
                    setBasicTitle(response.data.message || "No PM SKU master data found");
                    setBasicType("info");
                    setShow(true);
                    setRowData([]);
                    setFilteredData([]);
                }
            }
        } catch (error) {
            console.error("Error fetching PM SKU master data:", error);
            setBasicTitle("Failed to fetch PM SKU master data");
            setBasicType("error");
            setShow(true);
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    // Use Effect
    useEffect(() => {
        const getData = async () => {
            await getPmSkuMasterData();
        };
        getData();
    }, []);

    // Close Alert
    const closeAlert = () => {
        // Reset file inputs
        if (document.getElementById("pmBulkUploadFile")) {
            document.getElementById("pmBulkUploadFile").value = "";
        }
        
        setShow(false);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setOverlyBlock("show-n");
        setSliderOpen(false);
        resetFormData();
        setUploadedFileData([]);
        setFile(null);
    };

    return (
        <>
            <div className="container-fluid mt-3">
                <div style={{ zIndex: "9999999" }}>
                    <SweetAlert
                        show={show}
                        type={basicType}
                        title={basicTitle}
                        onConfirm={closeAlert}
                        style={{ fontSize: "9px" }}
                    >
                    </SweetAlert>
                </div>

                <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
                    <div className="col-sm-12">
                        <h1 className="col-sm-12" style={{color : "#B9366D", fontSize : "18px", fontWeight : "bold", fontFamily : "sans-serif"}}>PM SKU Master</h1>
                    </div>
                    
                    {/* Action Buttons - Upload and Add */}
                    <div className="col-sm-12 mt-3 mb-3" style={{ display: "flex", justifyContent: "flex-end", gap: "15px" }}>
                            <button 
                            type="button"
                            onClick={onClickAddNewPmSku}
                            style={{
                                padding: "8px 20px",
                                backgroundColor: "#93385D",
                                color: "#fff",
                                fontFamily: "sans-serif",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                                fontSize: "0.9rem",
                                // fontWeight: "bold",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <IoMdAdd style={{color : "#fff", fontSize :"18px"}}/>
                            {"  Add"}
                        </button>
                        <button 
                            type="button"
                            onClick={onClickUploadPmSkuMasterData}
                            style={{
                                padding: "8px 20px",
                                backgroundColor: "#F4EBEF",
                                color: "#93385D",
                                fontFamily: "sans-serif",
                                border: "2px solid #93385D",
                                borderRadius: "5px",
                                cursor: "pointer",
                                fontSize: "0.9rem",
                                // fontWeight: "bold",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <MdOutlineFileUpload style={{color : "#93385D", fontSize :"18px"}}/>
                            {" Upload"}
                        </button>
                        
                    </div>

                    {/* Data Grid */}
                    <div className="col-sm-12 p-0 pl-2 mt-6">
                        <div
                            className="ag-theme-alpine"
                            style={{
                                height: 'calc(100vh - 250px)',
                                width: "100%",
                                minHeight: '400px'
                            }}
                        >
                            <AgGridReact
                                rowData={filteredData}
                                columnDefs={columnWithDefs}
                                defaultColDef={defaultColDef}
                                domLayout="normal"
                                onGridReady={onGridReady}
                                onFirstDataRendered={onFirstDataRendered}
                                sideBar={sideBar}
                                statusBar={statusPanel}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Slider for Add/Edit/Upload */}
            <div className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`} style={{ width: "25%" }}>
                <div className="slider-header-container d-flex justify-content-between">
                    <p className="m-0p">{sliderTitle}</p>
                    <p
                        className="m-0p"
                        style={{ cursor: "pointer" }}
                        onClick={onClickingSliderCloseIcon}
                    >
                        X&nbsp;&nbsp;&nbsp;
                    </p>
                </div>

                {sliderType === 1 && (
                    <form style={{ padding: "20px" }} onSubmit={handleAddPmSku}>
                        <div className="form-group">
                            <label htmlFor="pm_sku_code" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>PM SKU Code <span style={{color :"red", marginLeft : "5px"}}>*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                id="pm_sku_code"
                                name="pm_sku_code"
                                onChange={(e) => setEditFormData({ ...editFormData, pm_sku_code: e.target.value })}
                                value={editFormData.pm_sku_code}
                                placeholder="Enter PM SKU Code"
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem"
                                }}
                                required
                                autoComplete="off"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="pm_type" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>PM Type <span style={{color :"red", marginLeft : "5px"}}>*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                id="pm_type"
                                name="pm_type"
                                placeholder="Enter PM Type"
                                onChange={(e) => setEditFormData({ ...editFormData, pm_type: e.target.value })}
                                value={editFormData.pm_type}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem"
                                }}
                                required
                                autoComplete="off"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="pm_category" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>PM Category <span style={{color :"red", marginLeft : "5px"}}>*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                id="pm_category"
                                name="pm_category"
                                placeholder="Enter PM Category"
                                onChange={(e) => setEditFormData({ ...editFormData, pm_category: e.target.value })}
                                value={editFormData.pm_category}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem"
                                }}
                                required
                                autoComplete="off"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="pm_sku_name" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>PM SKU Name <span style={{color :"red", marginLeft : "5px"}}>*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                id="pm_sku_name"
                                name="pm_sku_name"
                                placeholder="Enter PM SKU Name"
                                onChange={(e) => setEditFormData({ ...editFormData, pm_sku_name: e.target.value })}
                                value={editFormData.pm_sku_name}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem"
                                }}
                                required
                                autoComplete="off"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="pm_sku_sub_category" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>PM SKU Sub Category <span style={{color :"red", marginLeft : "5px"}}>*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                id="pm_sku_sub_category"
                                name="pm_sku_sub_category"
                                placeholder="Enter PM SKU Sub Category"
                                onChange={(e) => setEditFormData({ ...editFormData, pm_sku_sub_category: e.target.value })}
                                value={editFormData.pm_sku_sub_category}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem"
                                }}
                                required
                                autoComplete="off"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="lead_time" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>Lead Time</label>
                            <input
                                type="number"
                                className="form-control"
                                id="lead_time"
                                name="lead_time"
                                placeholder="Enter Lead Time"
                                onChange={(e) => setEditFormData({ ...editFormData, lead_time: e.target.value })}
                                value={editFormData.lead_time}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem"
                                }}
                                min="0"
                                autoComplete="off"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="moq" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>MOQ</label>
                            <input
                                type="number"
                                className="form-control"
                                id="moq"
                                name="moq"
                                placeholder="Enter MOQ"
                                onChange={(e) => setEditFormData({ ...editFormData, moq: e.target.value })}
                                value={editFormData.moq}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem"
                                }}
                                min="0"
                                autoComplete="off"
                            />
                        </div>

                        <div style={{
                            textAlign: "right",
                            marginTop: "10px"
                        }}>
                            <button
                                type="submit"
                                style={{
                                    backgroundColor: "#93385D",
                                    color: "#fff",
                                    padding: "10px 30px",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    fontSize: "0.9rem",
                                    fontWeight: "bold"
                                }}
                            >
                                ADD
                            </button>
                        </div>
                    </form>
                )}

                {sliderType === 2 && (
                    <div style={{ padding: "20px" }}>
                        <div className="d-flex justify-content-end mb-3">
                            <button
                                type="button"
                                onClick={downloadPmSkuExcelTemplate}
                                style={{
                                    backgroundColor: "#93385D",
                                    color: "#fff",
                                    padding: "8px 15px",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    fontSize: "0.8rem",
                                    fontWeight: "bold"
                                }}
                            >
                                Download Sample Template
                            </button>
                        </div>
                        
                        <input
                            type="file"
                            accept=".csv,.xlsx,.xls"
                            onChange={handleFileChange}
                            style={{
                                border: "1px solid #ccc",
                                width: "100%",
                                padding: "10px",
                                borderRadius: "5px",
                                backgroundColor: "#f9f9f9",
                                fontSize: "0.9rem",
                                marginBottom: "10px"
                            }}
                            id="pmBulkUploadFile"
                        />
                        
                        <p style={{
                            color: "red",
                            fontSize: "0.8rem",
                            margin: "0 0 20px 0",
                        }}>
                            *Accept .csv & .xlsx files only
                        </p>
                        
                        <div style={{ textAlign: "right", marginTop: "10px" }}>
                            <button
                                type="button"
                                onClick={onClickingFileSubmit}
                                style={{
                                    backgroundColor: "#93385D",
                                    color: "#fff",
                                    padding: "10px 30px",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    fontSize: "0.9rem",
                                    fontWeight: "bold"
                                }}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                )}

               {sliderType === 3 && (
                <div style={{ 
                    display: "flex", 
                    flexDirection: "column", 
                    height: "100%",
                    overflow: "hidden"
                }}>
                    <div style={{ 
                        flexGrow: 1, 
                        overflowY: "auto", 
                        padding: "20px",
                        maxHeight: "calc(100vh - 100px)" // Adjust this based on your header height
                    }}>
                        <form onSubmit={(e) => { e.preventDefault(); onClickingUpdatePmSku(); }}>
                            <div className="form-group">
                                <label htmlFor="edit_pm_sku_code" style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "5px",
                                    display: "block"
                                }}>
                                    PM SKU Code <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="edit_pm_sku_code"
                                    value={editFormData.pm_sku_code}
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                        fontSize: "0.9rem",
                                        backgroundColor: "#f9f9f9",
                                        cursor: "not-allowed",
                                        color: "#666",
                                        marginBottom: "15px"
                                    }}
                                    disabled
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="edit_pm_type" style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "5px",
                                    display: "block"
                                }}>
                                    PM Type <span style={{color: "red"}}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="edit_pm_type"
                                    value={editFormData.pm_type}
                                    onChange={(e) => handleEditInputChange('pm_type', e.target.value)}
                                    placeholder="Enter PM Type"
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                        fontSize: "0.9rem",
                                        marginBottom: "15px"
                                    }}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="edit_pm_category" style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "5px",
                                    display: "block"
                                }}>
                                    PM Category <span style={{color: "red"}}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="edit_pm_category"
                                    value={editFormData.pm_category}
                                    onChange={(e) => handleEditInputChange('pm_category', e.target.value)}
                                    placeholder="Enter PM Category"
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                        fontSize: "0.9rem",
                                        marginBottom: "15px"
                                    }}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="edit_pm_sku_name" style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "5px",
                                    display: "block"
                                }}>
                                    PM SKU Name <span style={{color: "red"}}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="edit_pm_sku_name"
                                    value={editFormData.pm_sku_name}
                                    onChange={(e) => handleEditInputChange('pm_sku_name', e.target.value)}
                                    placeholder="Enter PM SKU Name"
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                        fontSize: "0.9rem",
                                        marginBottom: "15px"
                                    }}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="edit_pm_sku_sub_category" style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "5px",
                                    display: "block"
                                }}>
                                    PM SKU Sub Category <span style={{color: "red"}}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="edit_pm_sku_sub_category"
                                    value={editFormData.pm_sku_sub_category}
                                    onChange={(e) => handleEditInputChange('pm_sku_sub_category', e.target.value)}
                                    placeholder="Enter PM SKU Sub Category"
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                        fontSize: "0.9rem",
                                        marginBottom: "15px"
                                    }}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="edit_lead_time" style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "5px",
                                    display: "block"
                                }}>
                                    Lead Time
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="edit_lead_time"
                                    value={editFormData.lead_time}
                                    onChange={(e) => handleEditInputChange('lead_time', e.target.value)}
                                    placeholder="Enter Lead Time"
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                        fontSize: "0.9rem",
                                        marginBottom: "15px"
                                    }}
                                    min="0"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="edit_moq" style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "5px",
                                    display: "block"
                                }}>
                                    MOQ
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="edit_moq"
                                    value={editFormData.moq}
                                    onChange={(e) => handleEditInputChange('moq', e.target.value)}
                                    placeholder="Enter MOQ"
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                        fontSize: "0.9rem",
                                        marginBottom: "15px"
                                    }}
                                    min="0"
                                />
                            </div>

                            <div className="form-group" style={{marginBottom:"70px"}}>
                                <label htmlFor="edit_is_active" style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "5px",
                                    display: "block"
                                }}>
                                    Status <span style={{color: "red"}}>*</span>
                                </label>
                                <Select
                                    id="edit_is_active"
                                    value={statusOptions.find(opt => opt.value === editFormData.is_active)}
                                    onChange={(selectedOption) => handleEditInputChange('is_active', selectedOption.value)}
                                    options={statusOptions}
                                    styles={selectStyles}
                                    placeholder="Select Status"
                                    isSearchable={false}
                                />
                            </div>

                            {/* {editFormData.qc_time !== undefined && (
                                <div className="form-group">
                                    <label htmlFor="edit_qc_time" style={{
                                        fontSize: "0.9rem",
                                        fontWeight: "bold",
                                        color: "#333",
                                        marginBottom: "5px",
                                        display: "block"
                                    }}>
                                        QC Time
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="edit_qc_time"
                                        value={editFormData.qc_time}
                                        onChange={(e) => handleEditInputChange('qc_time', e.target.value)}
                                        placeholder="Enter QC Time"
                                        style={{
                                            width: "100%",
                                            padding: "10px",
                                            borderRadius: "5px",
                                            border: "1px solid #ccc",
                                            fontSize: "0.9rem",
                                            marginBottom: "15px"
                                        }}
                                        min="0"
                                    />
                                </div>
                            )}

                            {editFormData.transit_time !== undefined && (
                                <div className="form-group">
                                    <label htmlFor="edit_transit_time" style={{
                                        fontSize: "0.9rem",
                                        fontWeight: "bold",
                                        color: "#333",
                                        marginBottom: "5px",
                                        display: "block"
                                    }}>
                                        Transit Time
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="edit_transit_time"
                                        value={editFormData.transit_time}
                                        onChange={(e) => handleEditInputChange('transit_time', e.target.value)}
                                        placeholder="Enter Transit Time"
                                        style={{
                                            width: "100%",
                                            padding: "10px",
                                            borderRadius: "5px",
                                            border: "1px solid #ccc",
                                            fontSize: "0.9rem",
                                            marginBottom: "15px"
                                        }}
                                        min="0"
                                    />
                                </div>
                            )} */}
                        </form>
                    </div>
                    
                    {/* Fixed button at the bottom */}
                    <div style={{
                        padding: "20px",
                        borderTop: "1px solid #eee",
                        backgroundColor: "#fff",
                        position: "sticky",
                        bottom: 0,
                        textAlign: "right"
                    }}>
                        <button
                            type="button"
                            onClick={onClickingUpdatePmSku}
                            style={{
                                padding: "10px 25px",
                                backgroundColor: "#93385D",
                                color: "#fff",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                                fontSize: "0.9rem",
                                fontWeight: "bold"
                            }}
                        >
                            UPDATE
                        </button>
                    </div>
                </div>

                    )}
            </div>

            {/* Loader and Overlays */}
            <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
            <div className={`overlay-block ${overlayBlock}`}></div>
            <div
                className={"overly-block " + overlyBlock}
                onClick={hideOverlySlideBlock}
            ></div>
        </>
    );
};

export default PmSkuMaster;